import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SNACK_BAR_DURATION_IN_MILLISECONDS } from '../../../shared/models/constants';
import { Router } from '@angular/router';

@Injectable()
export class ErrorResponseInterceptor implements HttpInterceptor {
    constructor(
        private snackbar: MatSnackBar,
        private router: Router
    ){}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap({
                error: (error) => {
                    if (error instanceof HttpErrorResponse && error.status >= 500 && error.status < 600) {
                        this.snackbar.open(
                            'Sorry for the inconvenience, it appears something went wrong.  Please reload the page and try again.', 'Dismiss',
                            {
                                duration: SNACK_BAR_DURATION_IN_MILLISECONDS,
                                verticalPosition: 'top',
                                panelClass: ['snackBar']
                            });
                    }
                    else if(error instanceof HttpErrorResponse && this.router.url !== '/registration') {
                        const errorCode = error.status || 404;
                        this.router.navigateByUrl(`error/${errorCode}`);
                    }
                }
            })
        );
    }
}
